import {DealListSort} from "@irati/types"

const FROM_PRICE_ASC = DealListSort.FromPriceAsc
const FROM_PRICE_DESC = DealListSort.FromPriceDesc
const flexiSortOpt = [FROM_PRICE_ASC, FROM_PRICE_DESC]

type SortOption = {
  value: DealListSort
  label: string
}
type Options = Partial<Record<"isFlexiPerks" | "isRewards", boolean>>

export function getSortOpts(sortOptions: SortOption[], {isFlexiPerks, isRewards}: Options) {
  if (!isFlexiPerks && !isRewards) {
    return sortOptions.filter((opt) => !flexiSortOpt.includes(opt.value))
  }

  return sortOptions
}
